// extracted by mini-css-extract-plugin
export default {"container":"Summary_container__80FyK","leftContainer":"Summary_leftContainer__8H1r1"};